
import DescriptionComponent from '@/views/DescriptionComponent.vue'
import TriangleImages from '@/views/TriangleImages.vue'

export default ({
  name: 'LandingPage',
  components: {
    DescriptionComponent,
    TriangleImages
  },
  props: {}
})
